import ElakayImage from '../../components/images/ElakayImage';
import React, { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa6";
import { elakay_API } from "../../config";

let __elakayInfoSource;
export const __setUserAvatarInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["cardUser"]?.[key] || fallback;

// Shared avatar used by CardUser (the card itself + its activation modal) --
// extracted so both places render the exact same avatar instead of two
// copies of the same lookup/fallback logic.
const UserAvatar = ({ userId, fullName, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const avatarUrl = userId ? `${elakay_API}/user_avatar/${encodeURIComponent(userId)}` : "";

  // Card lists currently reuse component positions across searches and
  // pagination. An error for user A must not permanently force the fallback
  // when that same component instance later renders user B.
  useEffect(() => {
    setFailed(false);
  }, [userId]);

  if (!avatarUrl || failed) {
    return (
      <span className={`carduser-circle-icon ${className}`}>
        <FaUser aria-label={fullName || __elakayText("t036", "User avatar")} />
      </span>
    );
  }

  return (
    <ElakayImage
      preset="avatar-tiny"
      className={`carduser-avatar-img ${className}`}
      src={avatarUrl}
      alt={fullName || __elakayText("t036", "User avatar")}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}

    />
  );
};

export default UserAvatar;
